import { DefaultContentBlock } from '../content-blocks/DefaultContentBlock';
import { ContentBlockType } from '../content-blocks/ContentBlockType';

class Navbar implements DefaultContentBlock {
  label = 'Navbar';

  component = 'Navbar';

  type = ContentBlockType.PASSIVE;

  async adapter (contents, extra, dataFetcher) {
    // const menuIds = contents.menus?.join(',');

    // load the menuData for each menuId
    const { data, error } = await dataFetcher.post('menus/' + contents.menu, {});

    if (error && typeof window === 'undefined') {
      console.error(
        'Adapter triggered an error!',
        error
      );
    }

    contents.menu = data[0];

    return contents;
  }
}

export { Navbar };
